import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <Row className="w-100" noGutters>
          <Col className="d-flex align-items-center justify-content-center">
            <img src="/icons/sectigo.png" alt="Secured by Sectigo" height="32" className="mr-2" />
            <div>Copyright &copy; 2020. ServicingUSA, LLC.<br className="d-sm-none" /> All Rights Reserved.</div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Footer;
